module.exports = __webpack_public_path__ + "static/img/2299.fd81fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/2299.png
// module id = Omg1
// module chunks = 12